import React, { FC, ReactNode, useState } from 'react'
import { SlideDown } from 'react-slidedown'

import { AccordionButton, AccordionPanel } from './index'

export interface AccordionItemProps {
  title?: string
  children: ReactNode
  isLastChild?: boolean
  isOpen?: boolean
  isBottomAligned?: boolean
  noPadding?: boolean
  noBorderWhenOpen?: boolean
  smallTitle?: boolean
}

const AccordionItem: FC<AccordionItemProps> = ({
  title = '',
  children,
  isLastChild = false,
  isOpen = true,
  isBottomAligned = false,
  noPadding = false,
  noBorderWhenOpen = false,
  smallTitle = false
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(isOpen)

  const handleOnClick = () => {
    setIsAccordionOpen(!isAccordionOpen)
  }

  return (
    <>
      {!isBottomAligned && (
        <AccordionButton
          handleOnClick={handleOnClick}
          isOpen={isAccordionOpen}
          isLastChild={isLastChild}
          noPadding={noPadding}
          noBorderWhenOpen={noBorderWhenOpen}
          smallTitle={smallTitle}
        >
          {title}
        </AccordionButton>
      )}
      <SlideDown transitionOnAppear={false}>
        {isAccordionOpen && (
          <AccordionPanel isOpen={isAccordionOpen} isBottomAligned={isBottomAligned}>
            {children}
          </AccordionPanel>
        )}
      </SlideDown>
      {isBottomAligned && (
        <AccordionButton handleOnClick={handleOnClick} isOpen={isAccordionOpen} isBottomAligned noPadding={noPadding}>
          {isAccordionOpen ? 'Show less' : 'Show more'}
        </AccordionButton>
      )}
    </>
  )
}

export default AccordionItem
